import React from 'react';
import classnames from 'classnames';
import { MoreOutlined } from '@ant-design/icons';
import { Dropdown, Button, Menu } from 'antd';
import styles from './index.less';

const renderDropdownContent = items => (
  <Menu>
    {React.Children.map(items, item => (!item ? null : (
      <Menu.Item key={item.key} disabled={item.props.disabled}>
        {item}
      </Menu.Item>
    )))}
  </Menu>
);

const MoreDropDown = ({ className, children, isChildrenMenu }) => (
  children && (
    <Dropdown overlay={isChildrenMenu ? children : renderDropdownContent(children)} trigger={['click']}>
      <Button className={classnames(styles.moreDropDownButton, className)} icon={<MoreOutlined />} type="text" />
    </Dropdown>
  )
);

MoreDropDown.defaultProps = {
  className: '',
  isChildrenMenu: false,
};

export default MoreDropDown;
